module.exports = __webpack_public_path__ + "img/7.5b3add56.png";